import { useTranslation } from 'react-i18next';

import { useUiVersion } from 'hooks';
import { themes } from './theme';
import { Button, GradientButton } from './button';

export const Submit = ({ children, disabled, className, invisible }) => {
  const { t } = useTranslation();
  const { isNew } = useUiVersion();
  if (invisible) {
    return null;
  }
  return (
    <Button theme={isNew ? themes.green : undefined} fontSize="16px" disabled={disabled} className={className}>
      <i className="fa fa-save" />
      {children ? children : t('grid.save')}
    </Button>
  );
};

export const CloseCardButton = ({ children, close }) => {
  const { t } = useTranslation();
  const { isNew } = useUiVersion();
  if (isNew) {
    return (
      <GradientButton
        theme={{ bg: 'var(--cp-surface)', border: 'var(--cp-border)', color: 'var(--cp-text)' }}
        fontSize="16px"
        onClick={close}
      >
        <i className="fa fa-times" />
        {children ? children : t('grid.closecard')}
      </GradientButton>
    );
  }
  return (
    <Button theme={themes.black} fontSize="16px" onClick={close}>
      <img src="/images/cross_icon_white.png" alt="" />
      {children ? children : t('grid.closecard')}
    </Button>
  );
};
